module.exports = __webpack_public_path__ + "img/stock4.4db9e575.png";